import useMutation from "src/hooks/useMutation";

function useWTScanCreate(id) {
  return useMutation({
    path: `/api/v1/warehouse-transfers/${id}/transfer-details/transferDetailId/import`,
    method: "POST",
    mutateRelatedDataList: {
      mutatePath: `/api/v1/warehouse-transfers/${id}`,
      shouldRevalidate: true,
    },
  });
}

export default useWTScanCreate;
